import { DashboardConstant } from '../actions/constants/DashboardConstant';
const initialState = 
{ 
    dashboardDS : {}, 
    productDS : {}, 
    serviceDS : {}, 
};
export const DashboardReducer = (state = initialState, action) => {
    switch (action.type) {
        case DashboardConstant.UPDATE:
            // IMP-200: inner switch 기준을 action.target 으로 정정 (기존 action.type 은 outer 와 동일 변수라 dead branch).
            switch (action.target) {
                case "dashboard": return { ...state, dashboardDS: action.data };
                case "product":   return { ...state, productDS: action.data };
                case "service":   return { ...state, serviceDS: action.data };
                default: return state;
            }
        default:
            return state
    }
}